import { computed, makeObservable, observable, toJS, runInAction, action } from 'mobx';
import { buildSelectOptions } from '../../utils/form';

class PostulantStore {
  data = {};

  currentStep = 1;

  _vacancy = {};

  _vacancyRequirement = {};

  _questions = [];

  _getData = {};

  countries = [];

  provinces = [];

  localities = [];

  _provincesAll = [];

  _localitiesAll = [];

  studylevels = [];

  studyStatus = [];

  studyAreas = [];

  institutions = [];

  bunAreas = [];

  bunSubAreasAll = [];

  bunSubAreas = [];

  seniorities = [];

  industries = [];

  drive = '';

  clientDrive = '';

  _alertaEmpleo = {};

  filesLoaded = [];

  actionBlockedSubmit = false;

  constructor() {
    makeObservable(this, {
      currentStep: observable,
      countries: observable,
      provinces: observable,
      localities: observable,
      studylevels: observable,
      studyStatus: observable,
      studyAreas: observable,
      institutions: observable,
      bunAreas: observable,
      bunSubAreas: observable,
      seniorities: observable,
      industries: observable,
      data: observable,
      filesLoaded: observable,
      actionBlockedSubmit: observable,
      vacancy: computed,
      questions: computed,
      getDataPostulant: computed,
      vacancyRequirement: computed,
      allow16yearsPostulants: computed,
      setCountries: action.bound,
      setProvinces: action.bound,
      setLocalities: action.bound,
      filterProvincies: action.bound,
      filterLocalites: action.bound,
      filterSubAreas: action.bound,
      driveKey: computed,
      clientAppDrive: computed,
      isActionBlockingSubmit: computed,
      alertaEmpleo: computed,
      setFilesLoaded: action.bound,
      deleteFileLoaded: action.bound,
      setActionBlockedSubmit: action.bound,
      filesLoadedList: computed
    });
    const initialState = {
      vacancy: window.__INITIAL_VACANCY,
      getData: window.__INITIAL_GETDATA,
      vacancyRequirement: window.__INITIAL_VACANCY_REQ,
      questions: window.__INITIAL_QUESTIONS,
      drive: window.__INITIAL_DRIVE,
      clientDrive: window.__INITIAL_CLIENTAPPDRIVE,
      alertaEmpleo: window.__INITIAL_ALERT_EMPLEO
    };
    if (initialState) {
      this.init(initialState);
    }
  }

  init(data) {
    this._vacancy = data.vacancy;
    this._getData = data.getData;
    this._vacancyRequirement = data.vacancyRequirement;
    this._questions = data.questions || [];
    this.drive = data.drive;
    this.clientDrive = data.clientDrive;
    this._alertaEmpleo = data.alertaEmpleo;
  }

  get alertaEmpleo() {
    return this._alertaEmpleo;
  }

  // #region datos computed
  get driveKey() {
    return this.drive;
  }

  get clientAppDrive() {
    return this.clientDrive;
  }

  get vacancy() {
    return this._vacancy;
  }

  get vacancyRequirement() {
    return this._vacancyRequirement;
  }

  get questions() {
    return this._questions;
  }

  get getDataPostulant() {
    return this._getData;
  }

  get allow16yearsPostulants() {
    return this._allow16yearsPostulants;
  }
  // #endregion datos computed

  filterSubAreas(areaID) {
    const bunSubAreasAll = [...toJS(this.bunSubAreasAll)];
    const filters = bunSubAreasAll.filter((data) => {
      return data.area === areaID;
    });
    runInAction(() => {
      this.bunSubAreas = buildSelectOptions(filters, 'nombre', 'id');
    });
  }

  // countries = () => {
  //   return toJS(this._countries);
  // };

  filterProvincies = (paisFind, customKeyFilter = 'countryId') => {
    const provAll = [...toJS(this._provincesAll)];
    const filters = provAll.filter((data) => {
      return data[customKeyFilter] === paisFind;
    });
    runInAction(() => {
      this.provinces = buildSelectOptions(filters, 'nombre', 'id').sort((a, b) => a.label.localeCompare(b.label));
    });
  };

  filterLocalites = (provincefind, customKeyFilter = 'provinceId') => {
    const locaAll = [...toJS(this._localitiesAll)];
    const filters = locaAll.filter((data) => {
      return data[customKeyFilter] === provincefind;
    });
    runInAction(() => {
      this.localities = buildSelectOptions(filters, 'nombre', 'id').sort((a, b) => a.label.localeCompare(b.label));
    });
  };

  setDataStudy = (data, name, keyId = 'id', keyName = 'nombre') => {
    this[name] = buildSelectOptions(data, keyName, keyId).sort((a, b) => a.label.localeCompare(b.label));
  };

  setDataObs = (data, name, keyId = 'id', keyName = 'nombre') => {
    this[name] = buildSelectOptions(data, keyName, keyId).sort((a, b) => a.label.localeCompare(b.label));
  };

  setCurrentStep = (step) => {
    runInAction(() => {
      this.currentStep = step;
    });
  };

  setCountries = ({ pais = [] }) => {
    this.countries = buildSelectOptions(pais, 'nombre', 'id');
  };

  setProvinces = (data) => {
    this._provincesAll = data;
  };

  setLocalities = (data) => {
    this._localitiesAll = data;
  };

  setBunSubAreas = (data) => {
    this.bunSubAreasAll = data;
  };

  get filesLoadedList() {
    return toJS(this.filesLoaded);
  }

  setFilesLoaded = (file) => {
    this.filesLoaded.push(file);
  };

  deleteFileLoaded = (fileType) => {
    const filesUploaded = this.filesLoaded;
    const fileSeeked = filesUploaded.find((file) => file.fileType === fileType);
    if (!fileSeeked) {
      throw new Error(`File with type ${fileType} not found`);
    }

    this.filesLoaded = this.filesLoaded.filter((item) => item.fileType !== fileType);
  };

  get isActionBlockingSubmit() {
    return this.actionBlockedSubmit;
  }

  setActionBlockedSubmit = (allowPerformSubmit) => {
    this.actionBlockedSubmit = allowPerformSubmit;
  };
}

export default PostulantStore;
